import { apiFetch } from "./apiClient";

export const userProfile = async (profilePayload) => {
  console.log(profilePayload);
  return apiFetch("/profile/update", {
    method: "POST", // change to PUT if backend uses PUT
    body: JSON.stringify(profilePayload),
  });
};
